export const environment = {
  production: false,
  useProxy: false,
  gba_gateway_api_url: `https://dev-gateway.globalbattery.org`,
};
